'use client';
import { FC } from 'react';

import { UserOutlined } from '@ant-design/icons';
import Tooltip from 'antd/es/tooltip';
import type { MenuProps } from 'antd/es/menu';

import STATIC_ROUTES from '@data/staticRoutes.json';
import { Down } from '@assets/icons';

import {
  LogoutButtonWrapper,
  StyledLogoutButton,
  MenuItem,
  UserNameLabel,
  Container,
  UserSubMenu,
  StyledDropdown,
} from './styled';
import { ITotalMileAmount } from './TotalMileAmount';
import UserMenuLink from './UserMenuLink';

export interface ILogoutButton extends ITotalMileAmount {
  fullName: string;
  isOnlyShowSignOut?: boolean;
}

const LogoutButton: FC<ILogoutButton> = ({ fullName }) => {
  return (
    <LogoutButtonWrapper>
      <MenuItem>
        <StyledLogoutButton>
          <Tooltip title={fullName} placement='bottom' />
        </StyledLogoutButton>
        <StyledDropdown menu={{ items }} arrow>
          <UserSubMenu onClick={(e) => e.preventDefault()}>
            <Container>
              <UserOutlined />
              <UserNameLabel>{fullName}</UserNameLabel>
              <Down />
            </Container>
          </UserSubMenu>
        </StyledDropdown>
      </MenuItem>
    </LogoutButtonWrapper>
  );
};

export default LogoutButton;

const items: MenuProps['items'] = [
  {
    key: '1',
    label: (
      <UserMenuLink
        href={STATIC_ROUTES.userInformation}
        label='Kullanıcı Bilgilerim'
      />
    ),
  },
  {
    key: '2',
    label: (
      <UserMenuLink
        href={STATIC_ROUTES.registeredPassengers}
        label='Kayıtlı Yolcularım'
      />
    ),
  },
  {
    key: '3',
    label: (
      <UserMenuLink
        href={STATIC_ROUTES.billingInformation}
        label='Fatura Bilgilerim'
      />
    ),
  },
  {
    key: '4',
    label: (
      <UserMenuLink
        href={STATIC_ROUTES.cardInformation}
        label='Kart Bilgilerim'
      />
    ),
  },
  {
    key: '5',
    label: <UserMenuLink href='/logout' label='Çıkış Yap' />,
  },
];
